import React, { useState } from 'react';
import PropTypes from 'prop-types';
import {
  Button,
} from '@edx/paragon';
import { PlayCircleFilled } from '@edx/paragon/icons';
import { injectIntl, defineMessages } from 'gatsby-plugin-react-intl';

import { intlShape } from '@prospectus/common/types/intlShape';
import videoShape from '@prospectus/common/types/videoShape';
import Video from '@prospectus/common/ui/Video';

const messages = defineMessages({
  'prospectus.course.header.mobileVideo': {
    id: 'prospectus.course.header.mobileVideo',
    defaultMessage: 'Watch the video',
    description: 'Button label that reveals the course video when clicked',
  },
});

function CourseVideo({
  intl,
  title,
  video,
  image,
}) {
  const [isPlayerInMobile, setIsPlayerInMobile] = useState(false);
  const showVideo = () => {
    setIsPlayerInMobile(true);
  };
  return (
    <>
      <div className={`${isPlayerInMobile ? '' : 'd-none d-sm-block d-md-block d-lg-block d-xl-block'}`}>
        <Video video={video} title={title} courseImage={image} className="header-video p-0" />
      </div>
      <div className={`${isPlayerInMobile ? 'd-none' : 'd-sm-none d-md-none d-lg-none d-xl-none'}`}>
        <Button
          variant="outline-primary"
          onClick={showVideo}
          className="w-100 mb-3"
        >
          <PlayCircleFilled className="mr-2" />
          {intl.formatMessage(messages['prospectus.course.header.mobileVideo'])}
        </Button>
      </div>
    </>
  );
}

CourseVideo.propTypes = {
  intl: intlShape.isRequired,
  title: PropTypes.string.isRequired,
  video: videoShape,
  image: PropTypes.shape({
    src: PropTypes.string.isRequired,
  }).isRequired,
};

CourseVideo.defaultProps = {
  video: undefined,
};

export default injectIntl(CourseVideo);
